<template>
	<div style="height: 100vh;width: 100vw; background-image: linear-gradient(to bottom, #fbc2e1, #a6c1e1);">
		<div class="login-wrapper">
			<div style="height: 90px;text-align: center;padding-top: 20px; font-size: 1.2rem;">欢迎来到儿康管家机构端档案管理系统</div>
			<div class="header">账号登录</div>
			<div class="form-wrapper"
				style="margin-top: 60px; display: flex; flex-direction: column; align-items: center;">
				<input type="text" placeholder="用户名" v-model="phone" class="input-item">
				<input type="password" placeholder="密码" v-model="password" class="input-item">
				<button class="btn" @click="do_login">登录</button>
			</div>
			<div class="msg">
				无账号？
				<a href="#">注册</a>
			</div>
		</div>
	</div>
</template>


<script>
	// @ is an alias to /src

	export default {
		data() {
			return {
				phone: "",
				password: '',
				login_text: "登录"
			}
		},
		created() {
			let code_list = new URLSearchParams(window.location.search)
			let sm = this.$smCrypto.sm2
			if (code_list.get("zh") && code_list.get("zh")) {
				this.phone = sm.doDecrypt(code_list.get("zh"), this.$key_private, '1')
				this.password = sm.doDecrypt(code_list.get("ma"), this.$key_private, '1')
			}

		},
		methods: {
			do_login() {
				this.login_text = '登录中...'
				this.$axios.post(
					this.$urls + "login/danan_tea_login", {
						params: {
							phone: this.phone,
							password: this.password
						}
					}, {
						// 配置请求头
						headers: {
							'Content-Type': 'application/json', // 明确指定 Content-Type
						},
					}
				).then((res) => {
					window.alert(`${res.data.desc}`)
					this.login_text = '登录成功'
					if (res.data.status == 202) {
						let sm = this.$smCrypto.sm2

						let tea_id = sm.doEncrypt(`${res.data.info.tea_id}`, this.$key_all, '1')
						let org_id = sm.doEncrypt(`${res.data.info.org_id}`, this.$key_all, '1')
						window.localStorage.setItem('org_id', res.data.info.org_id)
						window.localStorage.setItem('tea_token', res.data.tea_token)
						window.localStorage.setItem('tea_id', res.data.info.tea_id)
						window.localStorage.setItem('jz_token', res.data.jz_token)
						let tz = this.$router.resolve({
							name: "stu_list",
							query: {
								tea_id: tea_id,
								org_id: org_id,
								year: new Date().getFullYear()
							}
						})
						window.location.href = tz.href;
					}
				})
			}
		}
	}
</script>


<style>
	* {
		margin: 0;
		padding: 0;
	}

	.login-wrapper {
		background-color: #fff;
		width: 400px;
		height: 500px;
		border-radius: 15px;
		padding: 0 50px;
		position: relative;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.header {
		font-size: 38px;
		font-weight: bold;
		text-align: center;
		line-height: 20px;
	}

	.input-item {
		display: block;
		width: 100%;
		margin-bottom: 20px;
		border: 0;
		padding: 10px;
		border-bottom: 1px solid rgb(128, 125, 125);
		font-size: 15px;
		outline: none;
	}

	.btn {
		width: 300px;
		height: 50px;
		margin-top: 40px;
		font-size: 1.1rem;
		font-weight: 500;
		background-image: linear-gradient(to right, #fbc2e1, #a6c1e1);
		color: #ffffff;
	}

	.msg {
		text-align: center;
		margin-top: 10px;
		line-align: 88px;
	}

	a {
		text-decoration-line: none;
		color: #abc1ee;
	}
</style>